import React from 'react'

import { get } from 'lodash-es'

import { useSignUpStep } from '../SignUpProvider/sign-up-context'
import ClassLinkRequired from './ClassLinkRequired'
import CleverRequired from './CleverRequired'
import EmailMatch from './EmailMatch'
import EmailSignUp from './EmailSignUp'
import GoogleRequired from './GoogleRequired'
import IdDobMatch from './IdDobMatch'
import { StudentInvite, UnmatchedStudentInvite } from './InviteSent'
import MatchConfirm from './MatchConfirm'
import MiddleSchoolSignUp from './MiddleSchoolSignUp'
import SelectHighSchool from './SelectHighSchool'

const SIGN_UP_STEPS = {
  SelectHighSchool,
  EmailMatch,
  IdDobMatch,
  MatchConfirm,
  CleverRequired,
  ClassLinkRequired,
  GoogleRequired,
  StudentInvite,
  UnmatchedStudentInvite,
  EmailSignUp,
  MiddleSchoolSignUp,
}

const SignUpStep = () => {
  const signUpStep = useSignUpStep()

  const StepComponent = get(SIGN_UP_STEPS, signUpStep, SelectHighSchool)
  return <StepComponent />
}

export default SignUpStep
